import Vue from 'vue';
import VueRouter from 'vue-router';
import appRouter from './app-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue'),
  },
  {
    path: '/live',
    name: 'Live',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "live" */ '@/views/live/index.vue'),
  },
  {
    path: '/wxShare',
    name: 'wxShare',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "wxShare" */ '@/views/wechat-share/index.vue'),
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "userCenter" */ '@/views/user-center/index.vue'),
  },
  {
    path: '/userHome',
    name: 'userHome',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "userHome" */ '@/views/user-home/index.vue'),
  },
  {
    path: '/noLive',
    name: 'noLive',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "noLive" */ '@/views/no-live/index.vue'),
  },
  {
    path: '/videoList',
    name: 'videoList',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "videoList" */ '@/views/video-list/index.vue'),
  },
  {
    path: '/agreement/user',
    name: 'agreementUser',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "agreementUser" */ '@/views/agreement/user.vue'),
  },
  {
    path: '/agreement/privacy',
    name: 'agreementPrivacy',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "agreementPrivacy" */ '@/views/agreement/privacy.vue'),
  },
  {
    path: '/agreement/law',
    name: 'agreementLaw',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "agreementLaw" */ '@/views/agreement/law.vue'),
  },
  {
    path: '/nouser',
    name: 'nouser',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "nouser" */ '@/views/no-user/index.vue'),
  },
  {
    path: '/login/phone',
    name: 'loginPhone',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "loginPhone" */ '@/views/login/phone/index.vue'),
  },
  {
    path: '/login/phone/code',
    name: 'loginPhoneCode',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "loginPhoneCode" */ '@/views/login/phone/code.vue'),
  },
  {
    path: '/login/account',
    name: 'loginAccount',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "loginAccount" */ '@/views/login/account/index.vue'),
  },
  {
    path: '/retrievePassword',
    name: 'retrievePassword',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "retrievePassword" */ '@/views/retrieve-password/index.vue'),
  },
  {
    path: '/editUserInfo',
    name: 'editUserInfo',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "editUserInfo" */ '@/views/edit-user-info/index.vue'),
  },
  {
    path: '/playback',
    name: 'playback',
    meta: {
      title: '微医视频',
    },
    component: () => import(/* webpackChunkName: "playback" */ '@/views/playback/index.vue'),
  },
].concat(appRouter);
const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
